module.exports = __webpack_public_path__ + "img/katarina_bedrooms_8.0fa3a600.jpg";